module.exports = __webpack_public_path__ + "static/media/P29.60bc6212.png";